export default `vec3 boxFold(vec3 z, float foldingLimit) {
    return clamp(z, -foldingLimit, foldingLimit) * 2.0 - z;
}

vec3 sphereFold(vec3 z, float minRadius, float fixedRadius, out float factor) {
    float r2 = dot(z, z);
    float minRadius2 = minRadius * minRadius;
    float fixedRadius2 = fixedRadius * fixedRadius;

    if (r2 < minRadius2) {
        
        factor = fixedRadius2 / minRadius2;
        return z * factor;
    } else if (r2 < fixedRadius2) {
        
        factor = fixedRadius2 / r2;
        return z * factor;
    } else {
        
        factor = 1.0;
        return z;
    }
}

float sdMandelbox(vec3 p, int iterations, float scale, float foldingLimit, float minRadius, float fixedRadius) {
    vec3 z = p;
    float dr = 1.0; 
    float r = length(z);

    for (int i = 0; i < 20; i++) {
        if (i >= iterations) break;

        
        z = boxFold(z, foldingLimit);

        
        float factor;
        z = sphereFold(z, minRadius, fixedRadius, factor);
        dr = dr * abs(factor);

        
        z = z * scale + p;
        dr = dr * abs(scale) + 1.0;

        r = length(z);
        if (r > 10.0) break;
    }

    
    
    return r / abs(dr);
}

float sdMandelboxSimple(vec3 p, int iterations, float scale) {
    return sdMandelbox(p, iterations, scale, 1.0, 0.5, 1.0);
}

float sdMandelboxVariable(vec3 p, int iterations, float scale, float foldingLimit, float minRadius) {
    vec3 z = p;
    float dr = 1.0;
    float fixedRadius = 1.0;
    float minRadius2 = minRadius * minRadius;
    float fixedRadius2 = fixedRadius * fixedRadius;

    for (int i = 0; i < 20; i++) {
        if (i >= iterations) break;

        
        z = boxFold(z, foldingLimit);

        
        float r2 = dot(z, z);
        if (r2 < minRadius2) {
            float factor = fixedRadius2 / minRadius2;
            z *= factor;
            dr *= factor;
        } else if (r2 < fixedRadius2) {
            float factor = fixedRadius2 / r2;
            z *= factor;
            dr *= factor;
        }

        
        z = z * scale + p;
        dr = dr * abs(scale) + 1.0;
    }

    return length(z) / abs(dr);
}

struct MandelboxResult {
    float dist;
    float orbitTrap;
    float sphereFolds; 
};

MandelboxResult sdMandelboxColored(vec3 p, int iterations, float scale) {
    vec3 z = p;
    float dr = 1.0;
    float minDist = 1000.0;
    float sphereFoldCount = 0.0;

    float foldingLimit = 1.0;
    float minRadius = 0.5;
    float fixedRadius = 1.0;
    float minRadius2 = minRadius * minRadius;
    float fixedRadius2 = fixedRadius * fixedRadius;

    for (int i = 0; i < 20; i++) {
        if (i >= iterations) break;

        
        z = boxFold(z, foldingLimit);

        
        float r2 = dot(z, z);
        if (r2 < minRadius2) {
            float factor = fixedRadius2 / minRadius2;
            z *= factor;
            dr *= factor;
            sphereFoldCount += 1.0;
        } else if (r2 < fixedRadius2) {
            float factor = fixedRadius2 / r2;
            z *= factor;
            dr *= factor;
            sphereFoldCount += 0.5;
        }

        
        z = z * scale + p;
        dr = dr * abs(scale) + 1.0;

        
        minDist = min(minDist, length(z));
    }

    MandelboxResult result;
    result.dist = length(z) / abs(dr);
    result.orbitTrap = minDist;
    result.sphereFolds = sphereFoldCount;

    return result;
}

float sdMandelboxAnimated(vec3 p, int iterations, float scale, float time) {
    
    float foldingLimit = 1.0 + 0.2 * sin(time * 0.5);
    float minRadius = 0.5 + 0.1 * cos(time * 0.7);

    return sdMandelbox(p, iterations, scale, foldingLimit, minRadius, 1.0);
}`